import React from "react";

// A list of agents under what is being typed, like the address list: each with their photo (or initials), name, email
// or phone, and their network. Choosing one is the caller's.

const initialsOf = (name) =>
  String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");

export default function PeopleSuggestions({
  suggestions,
  highlighted,
  onHighlight,
  onPick,
}) {
  return (
    <ul
      role="listbox"
      aria-label="People"
      className="absolute bottom-full left-3 right-3 z-10 mb-1 max-h-72 overflow-y-auto rounded-xl border border-mediumgray bg-white py-1 shadow-lg"
    >
      {suggestions.map((person, index) => (
        <li
          key={`${person.kind}:${person._id}`}
          role="option"
          aria-selected={index === highlighted}
          // Keeps the cursor in the message box.
          onMouseDown={(event) => event.preventDefault()}
          onMouseEnter={() => onHighlight(index)}
          onClick={() => onPick(person)}
          className={`flex cursor-pointer items-center gap-3 px-3 py-2 text-sm ${index === highlighted ? "bg-lightgray" : ""}`}
        >
          {person.picture ? (
            <img src={person.picture} alt="" className="h-8 w-8 flex-none rounded-full object-cover" />
          ) : (
            <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-lightgray text-xs font-semibold text-darkergray">
              {initialsOf(person.name)}
            </span>
          )}
          <span className="min-w-0 flex-1">
            <span className="block truncate font-medium text-darkergray">{person.name}</span>
            {(person.email || person.phone) && (
              <span className="block truncate text-xs text-darkgray">{person.email || person.phone}</span>
            )}
          </span>
          {person.tag && (
            <span className="flex-none rounded bg-lightgray px-1.5 py-0.5 text-2xs font-semibold text-darkergray">
              {person.tag}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
